import * as THREE from 'three';
/**
 * Traverse the hierarchy in DFS order, and return the first object
 * for which `test(obj)` is truthy.
 * If none match, returns null.
 */
export const traverseUntil = (
  object: THREE.Object3D,
  test: (obj: THREE.Object3D) => boolean,
): THREE.Object3D | null => {
  if (test(object)) return object;

  for (const child of object.children) {
    const match = traverseUntil(child, test);
    if (match) return match;
  }

  return null;
};
